/* eslint-disable max-len */
import React, { Component } from 'react';
import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import moment from 'moment-timezone';

import Table from '../components/table/table';
import { history } from '../routers/AppRouter';
import ROUTES from '../data/routes';
import { getDiscountCouponHistory } from '../app/store/actions/discountCoupon';
import ModalComponent from '../components/modal';


class DiscountCouponHistoryPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: 20,
      page: 1,
      search: '',
      orderBy: 'DESC',
      field: 'createdAt',
      listHistory: [],
      totalRecord: 0,
      showModal: false,
      titleModal: '',
      titleModalBody: '',
    };

    this.tableHeader = [
      { key: 'couponCode', value: I18n.t('couponCode') },
      { key: 'description', value: I18n.t('couponDescription') },
      { key: 'clientId', value: I18n.t('clientId') },
      { key: 'clientName', value: I18n.t('client') },
      { key: 'purchaseId', value: I18n.t('orderCode') },
      { key: 'createdAt', value: I18n.t('dateOfUse') },
      // { key: 'status', value: I18n.t('status') },
    ];
  }

  componentDidMount() {
    this.getDiscountCouponHistory();
  }

  adjustData = async (count = 0, rows = []) => {
    const listHistory = rows.map((element, index) => ({
      key: index,
      couponCode: element.discountCoupon.couponCode,
      description: element.discountCoupon.description,
      clientId: element.clientId,
      clientName: element.client.nickname,
      purchaseId: element.purchaseId,
      createdAt: moment(element.createdAt).format('L LT'),
      // status: (element.status) ? I18n.t('activeOrder') : I18n.t('orderCanceled'),
    }));

    this.setState({
      totalRecord: count,
      listHistory,
    });
  }

  getDiscountCouponHistory = async () => {
    const {
      search, page, limit, orderBy = '', field = '',
    } = this.state;
    const skip = (page - 1) * limit;

    try {
      const { count = 0, rows = [] } = await this.props.getDiscountCouponHistory(
        limit, skip, search, orderBy, field,
      );

      await this.adjustData(count, rows);
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;
      if (error && error.message) {
        const messageError = (error.code && error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({
          showModal: true,
          titleModal: I18n.t('Error'),
          titleModalBody: messageError,
        });
      } else {
        this.setState({
          showModal: true,
          titleModal: I18n.t('Error'),
          titleModalBody: I18n.t('erroFetch'),
        });
      }
    }
  }

  sortTable = async (field, orderBy) => {
    await this.setState({ orderBy, field });
    await this.getDiscountCouponHistory();
  }

  searchTable = async (search = '', page = 1) => {
    await this.setState({ search, page });
    await this.getDiscountCouponHistory();
  }

  tableButtons = () => (
    <button
      type="button"
      onClick={() => { history.push(ROUTES.DISCOUNT_COUPON); }}
      className="btn btn-warning margin-right-15"
    >
      {I18n.t('return')}
    </button>
  )

  render() {
    const {
      limit, page, listHistory, totalRecord,
      titleModal, titleModalBody, showModal,
    } = this.state;

    return (
      <div className="main-div-tables">
        <ModalComponent
          title={titleModal}
          body={titleModalBody}
          visible={showModal}
          closeModal={() => this.setState({ showModal: false })}
          titleOkButtoon={I18n.t('ok')}
          size={{ width: '350px', height: '200px' }}
          showButtons
          confirmModal={() => this.setState({ showModal: false })}
        />
        <Table
          title={I18n.t('discountCouponHistory')}
          header={this.tableHeader}
          buttons={this.tableButtons()}
          lines={listHistory}
          page={page}
          perPage={limit}
          count={totalRecord || 0}
          searchItems={this.searchTable}
          showItemsCount
          sortTable={this.sortTable}
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getDiscountCouponHistory: (limit, skip, search, orderBy, field) => dispatch(getDiscountCouponHistory(limit, skip, search, orderBy, field)),
});

// eslint-disable-next-line no-unused-vars
const mapStateToProps = state => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(DiscountCouponHistoryPage);
